<template>
    <field :errors="errors" :label="label" :name="name">
        <input type="text" @blur="active=false" @focus="active=true" v-bind:value="value" @input="test($event)" placeholder="URL starting https:// or /">
        <div v-if="active" class="live-search">
            <div class="live-search__contents">
            <div class="result" @mousedown="setValue(value)" v-if="value">
                <i class="material-icons">launch</i> {{value}}
            </div>

            <div class="result result--help" v-if="!value">
                Enter a URL or select a page
            </div>

            <div v-for="page in pages" class="result" @mousedown="setPage(page)">
                <i class="material-icons">launch</i> {{page.name}}
            </div>
            </div>
        </div>
        <div class="help_text">{{help}}</div>
    </field>
</template>

<script>
    import Field from '@/components/Field.vue'

    export default {
        components: {
            Field,
        },
        props: [ 'help', 'label', 'name', 'value', 'errors'],
        data () {
            return {
                pages: null,
                active: false,
            }
        },
        computed: {
        },
        methods: {
            setPage (page){
                this.$emit('input', page.get_absolute_url)
            },
            setValue (value){
                this.$emit('input', value)
            },
            test(a){
                this.$emit('input', a.target.value)
            }
        },
        watch: {
            active () {
                // load the pages on the first time it becomes focused
                if(!this.pages){
                    this.$http.get('/pages/').then((data) => {
                        var pages = []
                        for(var i=0;i<data.data.length; i++){
                          var page = data.data[i]
                          pages.push(page)
                          for(var j=0;j<page.pages.length; j++){
                            var subpage = page.pages[j];
                            subpage.get_absolute_url = page.get_absolute_url + subpage.slug + '/'
                            pages.push(subpage)
                          }
                        }
                        this.pages = pages;
                    })
                }
            }
        }
    }
</script>
